var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "input",
    _vm._g(
      _vm._b(
        {
          ref: "fileInput",
          class: _vm.classes,
          attrs: {
            multiple: _vm.multiple ? "multiple" : null,
            accept: _vm.accept ? _vm.accept : null,
            type: "file"
          }
        },
        "input",
        _vm.props,
        false
      ),
      _vm.listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }